// Native
import { Box, ButtonGroup, Flex, HStack, IconButton, Image, Text, Button, VStack } from "@chakra-ui/react"
import { useNavigate } from "react-router"
import OneSignal from "react-onesignal"

// Custom
import { useColorMode } from "components/ui-old/color-mode"
import { UI } from "components"
import useUser from "hooks/useUser"
import { useData } from "hooks/useData"

export default function Header({ title, hiddenAlerts, backPath, ...props }){

    const navigate = useNavigate()
    const colorMode = useColorMode()
    const { toggleDrawer } = useData()
    const user = useUser()

    const handleLogout = async () => {
        if(!window.confirm('Tem certeza que deseja sair?')) return

        try {
            // await OneSignal.logout()
            localStorage.removeItem('@token')
            localStorage.clear()
        } catch(err){}

        setTimeout(() => { window.location.reload() }, 2000)
    }

    // Lógica para o texto do modo de cor
    const colorModeText = colorMode.colorMode === 'light' ? 'Escuro' : 'Claro'

    return(
        <>
            <Box w="100%" py={4} borderBottomWidth={1} mb={4} {...props}>
                <Flex justifyContent="space-between" alignItems="center">

                    <HStack alignItems="center">
                        <IconButton hideFrom="lg" variant="ghost" onClick={toggleDrawer}>
                            <UI.Icon name="menu" />
                        </IconButton>
                        { !backPath && <Image hideFrom="lg" src="/icon.png" h="30px" /> }
                        { !!backPath && <IconButton size="sm" variant="ghost" onClick={() => navigate(backPath)}><UI.Icon name="left" /></IconButton> }
                        <Text children={title} fontSize={{ base: 'lg', sm: 'lg', md: '2xl', lg: '2xl' }} />
                    </HStack>

                    <Box>
                        <ButtonGroup variant="ghost" alignItems="center" gap={2}>

                            {/* BOTÃO LOJA */}
                            <UI.Show visible={user.data?.consultant?.options?.adhesion !== 'required'}>
                                <Button onClick={() => navigate('/loja')} colorPalette="orange" height="auto" py={1} px={2}>
                                    <VStack gap={0}>
                                        <UI.Icon name="cart-shopp" />
                                        <Text fontSize="2xs" fontWeight="bold">Loja</Text>
                                    </VStack>
                                </Button>
                            </UI.Show>

                            {/* BOTÃO TEMA (SOL/LUA) */}
                            <Button onClick={colorMode.toggleColorMode} colorPalette="orange" height="auto" py={1} px={2}>
                                <VStack gap={0}>
                                    <UI.Icon name={colorMode.colorMode} />
                                    <Text fontSize="2xs" fontWeight="bold">{colorModeText}</Text>
                                </VStack>
                            </Button>

                            {/* BOTÃO SAIR - Ícone alterado para 'logout' (geralmente a porta com seta) */}
                            <Button onClick={handleLogout} colorPalette="red" height="auto" py={1} px={2}>
                                <VStack gap={0}>
                                    <UI.Icon name="exit" />
                                    <Text fontSize="2xs" fontWeight="bold">Sair</Text>
                                </VStack>
                            </Button>

                        </ButtonGroup>
                    </Box>
                </Flex>
            </Box>

            {/* Alertas abaixo permanecem iguais */}
            <UI.Show visible={!hiddenAlerts && user.data?.consultant?.active_month_status != 1}>
                <UI.Pressable onClick={() => navigate('/loja')}>
                    <UI.Alert status="warning" my={4} size="sm" title="Realize a sua ativação mensal">
                        Você não está ativo, e está com risco de perder os benefícios da Bonífica.
                    </UI.Alert>
                </UI.Pressable>
            </UI.Show>

            <UI.Show visible={!hiddenAlerts && !user.data?.has_security_code}>
                <UI.Pressable onClick={() => navigate('/ajustes')}>
                    <UI.Alert indicator={<UI.Icon name="key" />} status="error" my={4} size="sm" title="Configure seu código de segurança">
                        O seu código de segurança (antiga senha financeira) é necessário para realizar algumas ações no seu escritório.
                    </UI.Alert>
                </UI.Pressable>
            </UI.Show>

            <UI.Show visible={!hiddenAlerts && user.data?.options?.identity === 'waiting'}>
                <UI.Pressable onClick={() => navigate('/identidade')}>
                    <UI.Alert indicator={<UI.Icon name="identity" />} status="error" my={4} size="sm" title="Valide a sua identidade!">
                        Você ainda não enviou seus documentos de identificação. Envie o quanto antes para evitar perder a sua conta.
                    </UI.Alert>
                </UI.Pressable>
            </UI.Show>
        </>
    )
}